"use client"

import logoMenu from '../../assets/pictures/logo-2024.png';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import api from '../../services/api';

export default function SignIn() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Substitua pela URL da sua API de login
      const response = await api.post('/auth', {
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        throw new Error('Erro ao fazer login');
      }

      const data = await response.json();

      // Armazene o token (em localStorage ou cookies)
      localStorage.setItem('authToken', data.token);
      
      // Redirecione para a página após login bem-sucedido
      navigate('/dashboard');
      
    } catch (err) {
      setError('Credenciais inválidas. Por favor, tente novamente.');
      console.error('Erro no login:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 p-4">
      <form onSubmit={handleLogin} className="w-full max-w-md bg-white p-8 rounded shadow-md">
        <div className="mb-8 flex justify-center">
          <a href='/'>
            <img src={logoMenu} alt="logo" className='w-48' />
          </a>
        </div>
        <div className="mb-4">
          <h2 className="text-2xl text-gray-600 font-medium mb-6 text-center">acesso colaborador</h2>
          {error && (
            <div className="mb-4 p-2 bg-red-100 text-red-700 text-sm rounded">
              {error}
            </div>
          )}
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="digite seu e-mail"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="**********"
            required
          />
        </div>
        <button
          type="submit"
          disabled={loading}
          className={`w-full ${loading ? 'bg-gray-400' : 'bg-gray-600'} text-white py-2 rounded hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500`}
        >
          {loading ? 'Carregando...' : 'Acessar'}
        </button>
        <p className="text-sm text-center text-gray-600 p-6 text-sm">
          Acessar como administrador? <a href="/painel/sign-admin" className="text-blue-600 hover:underline">login</a>
        </p>
      </form>
    </div>
  )
}